import Vue from "vue";

export default ({ store }) => {
    Vue.filter("lang", (key) => {
        return store.getters["globalvars/getMessage"](key);
    });
};
